import { css } from '@emotion/core'
import { colors, spacing } from 'styles/variables'
import * as MQ from 'styles/media-queries'

export const header = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: #000000;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  
  ${MQ.NOT_TABLETS} {
    display: none;
  }
`

export const headerContent = css`
  padding: ${spacing(4, 2, 2, 2)};
`

export const titleContainer = css`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${spacing(2)};
`

export const logo = css`
  width: 24px;
  height: 24px;
  object-fit: contain;
`

export const title = css`
  font-weight: 600;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
` 